import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export function formatFloatToPTBR(value) {
    return value?.toLocaleString('pt-BR', {
		maximumFractionDigits: 2,
	}) ?? 0;
}